import { ChevronDown } from 'lucide-react';
import React, { useState } from 'react';

import { useLocalStorageState } from 'base/utils/events';

import Product from './Product';
import ProductPriceQty from './ProductPriceQty';

/* items display */
function CatalogProduct({
    delivery_route,
    buying_for_user,
    catalog_product, price, qty: _qty, order, cart,
    className,
    grid, // displayed in vertical if true, else horizontal
    can_modify: _can_modify, // is view only
    image_height,
    onViewProduct,
}){
    const can_modify = _can_modify !== undefined ? _can_modify : !delivery_route.is_ordering_frozen;
    const [cp, setCp] = useState(catalog_product);
    const [area] = useLocalStorageState('area');

    if (
        delivery_route?.other_config?.hide_out_of_stock_products 
            && (!cp?.qty || cp.qty <= 0)
    ) {
        return null;
    }

    return (
        <div className={`tw-relative tw-px-3 tw-py-4 tw-bg-white tw-h-full ${className || ""} ${grid ? '' : 'tw-flex tw-gap-4'}`}>
            <Product.Image grid={grid} image_height={image_height}
                cp={cp} delivery_route={delivery_route} 
                onClick={() => !can_modify || !onViewProduct ? null : onViewProduct(cp)} 
            />
            {can_modify ? <Product.Points cp={cp} /> : null}
            <div className={grid ? '' : 'tw-flex-1'}>
                {cp?.sale
                ? <div className='tw-absolute tw-right-0 tw-top-5 tw-w-12 tw-text-center tw-rounded-l-lg tw-text-xxs tw-bg-red-500 tw-text-white tw-p-1 tw-z-10'>
                    On Sale
                </div>
                : null
            }
                <Product.Title cp={cp} className={grid ? 'tw-text-xs' : 'tw-mb-1 tw-text-sm'} />
                {
                    cp.sku && !delivery_route.other_config.hide_sku_on_listing
                    ? <Product.SKU cp={cp} className={grid ? 'tw-text-xxs tw-my-1' : 'tw-mb-1 tw-text-xxs'} />
                    : null
                }
                <div className="tw-flex tw-items-center tw-text-xs tw-text-gray-500 tw-mt-1 tw-mb-1">
                    <Product.Unit cp={cp} />
                    {!can_modify ? <Product.PurchasedCount cp={cp} className='tw-px-4' /> : null}
                    {cp.has_discounts && can_modify && onViewProduct
                        ? <Product.OffersTag className='tw-ml-2' onClick={() => onViewProduct(cp)} />
                        : null
                    }              
                </div>
                {
                    !can_modify
                    ?   <Product.PriceQtyReadOnly delivery_route={delivery_route} 
                        price={price || cp?.price} qty={_qty} />
                    :   cp.data?.is_bfc_only && !buying_for_user?._id
                        ?   <Product.Enquire cp={cp} delivery_route={delivery_route} />
                        :   <ProductPriceQty
                                source="from parent"
                                catalog_product={cp}
                                setCp={setCp}
                                price={price}
                                delivery_route={delivery_route}
                                buying_for_user={buying_for_user}
                                cart={cart}
                                order={order}
                                onViewProduct={onViewProduct}
                            />
                }
                {
                    cp.variant_info
                        ? <div className='hflex tw-gap-1 tw-mt-3'>
                            <Product.VariantsInfo cp={cp} />
                            {can_modify && onViewProduct && cp.variant_group_id
                                ? <button className='tw-text-xs tw-shrink-0 tw-font-bold tw-flex tw-items-end tw-gap-x-0.5' onClick={() => onViewProduct(cp)}
                                    type='button'
                                >
                                    Options <ChevronDown size={14} />
                                </button>
                                : null
                            }
                        </div>
                        : null
                }
                {can_modify && !(cp.data?.is_bfc_only && !buying_for_user?._id) ? <Product.DiscountsList cp={cp} cart={cart}  /> : null}
                {can_modify ? <Product.BfcRecommendedData cp={cp} /> : null}
            </div>
        </div>
    )
}

export default CatalogProduct
